import {Component, EventEmitter, Output} from "@angular/core";

@Component({
  selector: 'app-search-box-map',
  template: `<div id="text-input-card">
    <input
      #textInput
      type="text"
      id="text-input"
      placeholder="Nach einem Ort suchen"
      (keydown.enter)="findPlaces(textInput.value)"/>

    <input type="button"
           id="text-input-button"
           value="Suchen"
           (click)="findPlaces(textInput.value)"/>
  </div>`,
  styles: `
  #text-input-card {
    width: 100%;
    background-color: #fff;
    border-radius: 5px;
    box-shadow: rgba(0, 0, 0, 0.35) 5px 15px;
    margin: 2px;
    padding: 5px;
  }

  #text-input {
    width: 75%;
    padding: 10px;
    margin: 0;
    box-sizing: border-box;
  }

  #text-input-button {
    display: inline-block;
    margin: 6px;
    width: 17%;
    padding: 0.6rem 0.75rem;
    color: #fff;
    background-color: #2563eb;
    border: none;
    border-radius: 0.375rem;
    cursor: pointer;
  }`
})
export class SearchBoxMapComponent {
  @Output() placeLogged = new EventEmitter<google.maps.places.Place[]>();

  async findPlaces(query: string) {
    if (!query.trim()) return;

    let {Place} = await google.maps.importLibrary('places') as google.maps.PlacesLibrary;

    let {places} = await Place.searchByText({
      textQuery: query,
      fields: ['displayName', 'location', 'formattedAddress', 'editorialSummary', 'googleMapsURI', 'addressComponents'],
      maxResultCount: 1,
    });

    if (!places.length) return;
    this.placeLogged.emit(places);
  }
}


